
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import { PLATFORM_CODE } from "../../../../../engines/services/ossService";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import { getOilfieldConfig, getOilfieldConfigH5 } from "./oilfieldConfig";

class oilfieldData {
    private data: oilfieldDataType = null;
    getData() {
        return this.data
    }
    init(data: oilfieldDataType) {
        this.data = null;
        let curDay = data_control.getCurrDateDayString();
        if (!data || !data.mineInfo) {
            this.data = {
                mineTimes: 0,
                mineInfo: [],
                lastRefreshTime: curDay,
            }
            let OilFieldConifg = getOilfieldConfig;
            if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
                OilFieldConifg = getOilfieldConfigH5;
            }
            
            for (const key in OilFieldConifg) {
                if (Object.prototype.hasOwnProperty.call(OilFieldConifg, key)) {
                    const element = OilFieldConifg[key];
                    this.data.mineInfo.push({ id: element.id, ismine: false })
                }
            }
            this.saveData();
        } else {
            this.data = data;

            if (curDay != data.lastRefreshTime) {
                data.lastRefreshTime = curDay;
                this.newDayRefresh();
            }
        }
    }

    saveData() {
        NormalGameManager._instance.setGameData({oilfieldData: this.data});
        O1HD.emit(MessageEventKind.EventName.GAME_OILFIELD_DATA);
    }


    newDayRefresh() {
        this.data.mineTimes = 0;
        this.data.mineInfo = [];
        
        let OilFieldConifg = getOilfieldConfig;
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            OilFieldConifg = getOilfieldConfigH5;
        }
        
        for (const key in OilFieldConifg) {
            if (Object.prototype.hasOwnProperty.call(OilFieldConifg, key)) {
                const element = OilFieldConifg[key];
                this.data.mineInfo.push({ id: element.id, ismine: false })
            }
        }
        this.saveData();
    }
    addMineTimes() {
        this.data.mineTimes++;
        this.saveData();
    }
    setOilfield(id: number) {
        for (let data of this.data.mineInfo) {
            if (data.id == id) {
                data.ismine = true;
                break;
            }
        }
        this.saveData();
    }
}
export interface oilfieldDataType {
    /**开采次数 */
    mineTimes: number,
    /**开采信息 */
    mineInfo: { id: number, ismine: boolean }[],
    /** 最后刷新时间 */
    lastRefreshTime: string;
}
export const oilfieldDataHelp = new oilfieldData();

export const OilFieldCollect = [50032, 50033, 50034, 50035, 50036];